var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"type":_vm.type,"block":_vm.block,"color":_vm.primary?'primary':'',"plain":_vm.plain,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }